import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import { Trans } from "react-i18next";

import ProductTags from "../../components/Tags/ProductTags";
import { COLOR_PICKER_DEFAULTS } from "../../utils/constants";
import LazyImage from "../Shared/LazyImage";
import LoadingOverlay from "../Loaders/LoadingOverlay";
import { handleExternalLink } from "../../utils/ExternalLinksHelper";
import { getCurrencyDropdown } from "../../utils/CurrencyHelper";

const OrganizationProfileView = ({
    organization,
    setEditMode,
    flag,
    isLoading,
}) => {
    const [currencies, setCurrencies] = useState([]);

    useEffect(() => {
        getCurrencyDropdown(setCurrencies);
    }, []);

    const choosenCurrency =
        currencies.find(
            (elem) => elem.value === organization.defaultCurrencyId
        ) || {};
    return (
        <>
            <div className="card-table shadow">
                <LoadingOverlay active={isLoading}>
                    <div className="upload-img-box flex">
                        <div className="choose-img-wrapper">
                            <LazyImage
                                src={
                                    organization?.image ||
                                    require("../../assets/images/org-avatar.png")
                                        .default
                                }
                                alt="Upload avatar"
                            />
                        </div>
                        <div className="w-full">
                            <div className="flex justify-between">
                                <h3 className="medium-title-bold mr-2">
                                    <Trans i18nKey="affiliateInformation">
                                        Affiliate Information
                                    </Trans>
                                </h3>
                                <div className="text-primary-blue cursor-pointer">
                                    <i
                                        onClick={() => {
                                            setEditMode(true);
                                        }}
                                        className="fas fa-edit"
                                    ></i>
                                </div>
                            </div>
                            <hr className="mt-2 mb-5" />
                            <div className="tags mb-6">
                                <h4 className="uppercase text-xs">
                                    <Trans i18nKey="name">Name</Trans>
                                </h4>
                                <p className="w-6/12 capitalize">
                                    {organization?.name}
                                </p>
                            </div>
                            <div className="flex flex-column-start-mobile">
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="email">Email</Trans>
                                    </h4>
                                    {organization?.email ? (
                                        <Link
                                            to="#"
                                            onClick={(e) => {
                                                window.location = `mailto:${organization?.email}`;
                                                e.preventDefault();
                                            }}
                                        >
                                            <p className="w-full underline text-blue-600">
                                                {organization?.email}
                                            </p>
                                        </Link>
                                    ) : (
                                        <p>---</p>
                                    )}
                                </div>
                                <span className="mx-2"></span>
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="currency">
                                            Currency
                                        </Trans>
                                    </h4>
                                    <p>{choosenCurrency.label}</p>
                                </div>
                            </div>
                            <div className="tags mb-6">
                                <h4 className="uppercase text-xs">
                                    <Trans i18nKey="abbreviation">
                                        Abbreviation
                                    </Trans>
                                </h4>
                                <p className="w-6/12">
                                    {organization?.abbreviation || "---"}
                                </p>
                            </div>
                            <div className="tags mb-6">
                                <h4 className="uppercase text-xs">
                                    <Trans i18nKey="about">---</Trans>
                                </h4>
                                <p className="w-full">
                                    {organization?.about || "---"}
                                </p>
                            </div>
                            <div className="flex flex-column-start-mobile">
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="country">Country</Trans>
                                    </h4>
                                    {flag || <p>---</p>}
                                </div>
                                <span className="mx-2"></span>
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="address">Address</Trans>
                                    </h4>
                                    <p className="w-6/12 text-justify">
                                        {organization?.address || "---"}
                                    </p>
                                </div>
                            </div>
                            {(organization?.linkedin ||
                                organization?.website) && (
                                <div className="tags mb-6">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="links">Links</Trans>
                                    </h4>
                                    <div className="flex-col">
                                        {organization?.website && (
                                            <div
                                                className="cursor-pointer mb-1"
                                                onClick={() =>
                                                    handleExternalLink(
                                                        organization?.website
                                                    )
                                                }
                                            >
                                                <i className="fas fa-link fa-xs mr-2"></i>
                                                <p className="inline underline text-blue-600">
                                                    {organization?.website}
                                                </p>
                                            </div>
                                        )}
                                        {organization.linkedin && (
                                            <div
                                                className="cursor-pointer mb-4"
                                                onClick={() =>
                                                    handleExternalLink(
                                                        organization?.linkedin
                                                    )
                                                }
                                            >
                                                <img
                                                    className="inline mr-2"
                                                    src={
                                                        require("../../assets/images/linkedIn.png")
                                                            .default
                                                    }
                                                    alt="linkedin logo"
                                                    width="14"
                                                    height="17"
                                                />
                                                <p className="inline underline text-blue-600">
                                                    {organization.linkedin}
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            <div className="flex flex-column-start-mobile">
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="industries">
                                            industries
                                        </Trans>
                                    </h4>
                                    <ProductTags
                                        tags={organization?.industries}
                                    />
                                </div>
                                <span className="mx-2"></span>
                                <div className="tags mb-6 w-full">
                                    <h4 className="uppercase text-xs">
                                        <Trans i18nKey="backgroundColor">
                                            Background Color
                                        </Trans>
                                    </h4>
                                    <div
                                        className="color-square-block"
                                        style={{
                                            backgroundColor:
                                                organization?.backgroundColor ||
                                                COLOR_PICKER_DEFAULTS[0],
                                            cursor: "unset",
                                        }}
                                    ></div>
                                </div>
                            </div>

                            <div className="tags mb-6 sm:w-2/4 lg:w-4/6 xl:full">
                                <h4 className="uppercase text-xs">
                                    <Trans i18nKey="links">Links</Trans>
                                </h4>
                                <div className="md:w-5/6 xl:w-6/12 text-justify">
                                    <button
                                        className={`default-transparent-btn w-full block mb-2 ${
                                            !organization.privacyPolicy
                                                ? "disabled"
                                                : ""
                                        }`}
                                        disabled={!organization.privacyPolicy}
                                        onClick={() =>
                                            handleExternalLink(
                                                organization.privacyPolicy
                                            )
                                        }
                                    >
                                        <div className="flex items-center">
                                            <i className="fas fa-key mr-2"></i>
                                            <span>Privacy Policy</span>
                                        </div>
                                    </button>
                                    <button
                                        className={`default-transparent-btn w-full block mb-2 custom-padding-button ${
                                            !organization?.termsAndConditions
                                                ? "disabled"
                                                : ""
                                        }`}
                                        disabled={
                                            !organization?.termsAndConditions
                                        }
                                        onClick={() =>
                                            handleExternalLink(
                                                organization.termsAndConditions
                                            )
                                        }
                                    >
                                        <div className="flex items-center">
                                            <i className="fas fa-file-signature mr-2"></i>
                                            <span>Terms And Conditions</span>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </LoadingOverlay>
            </div>
        </>
    );
};

export default OrganizationProfileView;
